import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
    FaArrowRight, FaUserTie, FaUsers, FaBook, FaUserMd,
    FaGraduationCap, FaMicroscope, FaAward, FaCalculator,
    FaGlobe, FaBullhorn, FaBriefcase, FaUserGraduate,
    FaLaptopCode, FaSearch, FaHistory, FaDraftingCompass,
    FaRunning, FaBrain, FaBalanceScale, FaCogs, FaUsersCog,
    FaFileAlt, FaChartLine, FaUniversity, FaStethoscope, FaFlask
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import styles from "./Departments.module.css";
import { testUrl } from "../home/BaseData";

const Department = () => {
    const { t, i18n } = useTranslation();
    const [rectors, setRectors] = useState([]);

    useEffect(() => {
        axios
            .get(testUrl + "/api/rectors/")
            .then((response) => {
                let data = response.data;
                // Filter out rector records with no position set (prevents duplicate/empty cards)
                data = data.filter(r => r.position_uz && r.position_uz.trim() !== '');
                const normalize = (str) => str ? str.toLowerCase().replace(/['`’"“”]/g, "").trim() : "";

                const manualSequence = [
                    "Xalqaro hamkorlik bo‘yicha prorektor",
                    "Xalqaro hamkorlik va reytinglar bilan ishlash boshqarmasi",
                    "Rektor apparati – rektor yordamchisi va maslahatchilari",
                    "Inson resurslarini boshqarish boshqarmasi",
                    "Universitet axborot xizmati",
                    "Yuriskonsult, “Komplayens nazorat”",
                    "Kengashlar va majlislar kotibi",
                    "Ijro intizomi, arxiv va murojaatlar bilan ishlash bo‘limi"
                ];

                let rectorIndex = data.findIndex(r => r.position_uz && normalize(r.position_uz).includes('rektor') && !normalize(r.position_uz).includes('prorektor'));

                if (rectorIndex === -1) {
                    // Create a fallback placeholder for the Rector if deleted/missing from DB
                    const fallbackRector = {
                        id: 'rector-manual-section',
                        position_uz: "Rektor",
                        position_ru: "Ректор",
                        position_en: "Rector",
                        departments: [],
                        is_manual_rector: true,
                        disableLink: true
                    };
                    data.unshift(fallbackRector);
                    rectorIndex = 0;
                }

                if (rectorIndex !== -1) {
                    const rector = data[rectorIndex];
                    let currentDepts = rector.departments || [];
                    const usedIds = new Set();

                    const newDepts = manualSequence.map(name => {
                        const normName = normalize(name);

                        // SPECIAL CASE: Force ID 185 for "Xalqaro hamkorlik bo‘yicha prorektor"
                        if (name.includes("Xalqaro hamkorlik bo‘yicha prorektor")) {
                            const targetId = 274;
                            // Try to find in data to mark as hidden/used
                            let specificRector = data.find(r => r.employee && r.employee.id === targetId);

                            if (specificRector) {
                                const uniqueId = 'emp-' + specificRector.employee.id;
                                if (!usedIds.has(uniqueId)) {
                                    usedIds.add(uniqueId);
                                    specificRector.hidden = true;
                                    return {
                                        id: targetId,
                                        name_uz: name, // Override name
                                        name_ru: specificRector.position_ru,
                                        name_en: specificRector.position_en,
                                        type: 'employee',
                                        short_id: 'emp-' + specificRector.id
                                    };
                                }
                            }
                            // Force link even if not found
                            return {
                                id: targetId,
                                name_uz: name,
                                type: 'employee',
                                short_id: 'emp-' + targetId,
                                is_new: false
                            };
                        }

                        // SPECIAL CASE: Force ID 185 for "Xorijiy ta’lim hamkorligi markazlari rahbari-prorektor"
                        if (name.includes("Xorijiy ta’lim hamkorligi markazlari rahbari-prorektor") || name.includes("Xorijiy ta’lim")) {
                            const targetId = 185;
                            let specificRector = data.find(r => r.employee && r.employee.id === targetId);
                            if (specificRector) {
                                const uniqueId = 'emp-' + specificRector.employee.id;
                                if (!usedIds.has(uniqueId)) {
                                    usedIds.add(uniqueId);
                                    // Note: Do NOT set hidden=true here if we want it to also show up as a separate section later
                                    return {
                                        id: targetId,
                                        name_uz: "Xorijiy ta’lim hamkorligi markazlari rahbari-prorektor",
                                        name_ru: specificRector.position_ru,
                                        name_en: specificRector.position_en,
                                        type: 'employee',
                                        short_id: 'emp-' + specificRector.id
                                    };
                                }
                            }
                            return {
                                id: targetId,
                                name_uz: "Xorijiy ta’lim hamkorligi markazlari rahbari-prorektor",
                                type: 'employee',
                                short_id: 'emp-' + targetId,
                                is_new: false
                            };
                        }


                        // SPECIAL CASE: Force short_id for "Xalqaro hamkorlik va reytinglar bilan ishlash boshqarmasi"
                        if (name.includes("Xalqaro hamkorlik va reytinglar bilan ishlash boshqarmasi")) {
                            const targetShortId = "xalqaro-hamkorlik-bolimi";

                            // Try to find in current departments to mark as used
                            // Use flexible matching
                            let foundDept = currentDepts.find(d => {
                                if (usedIds.has(d.id)) return false;
                                const dbName = normalize(d.name_uz);
                                return dbName.includes(normName) || normName.includes(dbName);
                            });

                            if (foundDept) {
                                usedIds.add(foundDept.id);
                                return {
                                    ...foundDept,
                                    name_uz: name,
                                    short_id: targetShortId
                                };
                            } else {
                                // Force new item with working link
                                return {
                                    id: 'manual-' + Math.random(),
                                    name_uz: name,
                                    short_id: targetShortId,
                                    is_new: false // Allow link to be generated based on short_id
                                };
                            }
                        }

                        // SPECIAL CASE: Force short_id for "Inson resurslarini boshqarish boshqarmasi"
                        if (name.includes("Inson resurslarini boshqarish boshqarmasi")) {
                            const targetShortId = "inson-resurslari";

                            let foundDept = currentDepts.find(d => {
                                if (usedIds.has(d.id)) return false;
                                const dbName = normalize(d.name_uz);
                                return dbName.includes(normName) || normName.includes(dbName);
                            });

                            if (foundDept) {
                                usedIds.add(foundDept.id);
                                return {
                                    ...foundDept,
                                    name_uz: name,
                                    short_id: targetShortId
                                };
                            } else {
                                return {
                                    id: 'manual-' + Math.random(),
                                    name_uz: name,
                                    short_id: targetShortId,
                                    is_new: false // Allow link to be generated based on short_id
                                };
                            }
                        }

                        // SPECIAL CASE: Force short_id for "Universitet axborot xizmati"
                        if (name.includes("Universitet axborot xizmati")) {
                            const targetShortId = "axborot-xizmati";

                            let foundDept = currentDepts.find(d => {
                                if (usedIds.has(d.id)) return false;
                                const dbName = normalize(d.name_uz);
                                return dbName.includes(normName) || normName.includes(dbName);
                            });

                            if (foundDept) {
                                usedIds.add(foundDept.id);
                                return {
                                    ...foundDept,
                                    name_uz: name,
                                    short_id: targetShortId
                                };
                            } else {
                                return {
                                    id: 'manual-' + Math.random(),
                                    name_uz: name,
                                    short_id: targetShortId,
                                    is_new: false
                                };
                            }
                        }

                        // SPECIAL CASE: Force short_id for "Yuriskonsult, “Komplayens nazorat”"
                        if (name.includes("Yuriskonsult") || name.includes("Komplayens")) {
                            const targetShortId = "yuriskonsult";

                            let foundDept = currentDepts.find(d => {
                                if (usedIds.has(d.id)) return false;
                                const dbName = normalize(d.name_uz);
                                return dbName.includes(normName) || normName.includes(dbName);
                            });

                            if (foundDept) {
                                usedIds.add(foundDept.id);
                                return {
                                    ...foundDept,
                                    name_uz: name,
                                    short_id: targetShortId
                                };
                            } else {
                                return {
                                    id: 'manual-' + Math.random(),
                                    name_uz: name,
                                    short_id: targetShortId,
                                    is_new: false
                                };
                            }
                        }

                        // SPECIAL CASE: Force short_id for "Kengashlar va majlislar kotibi"
                        if (name.includes("Kengashlar va majlislar kotibi")) {
                            const targetShortId = "kengashlar-va-majlislar";

                            let foundDept = currentDepts.find(d => {
                                if (usedIds.has(d.id)) return false;
                                const dbName = normalize(d.name_uz);
                                return dbName.includes(normName) || normName.includes(dbName);
                            });

                            if (foundDept) {
                                usedIds.add(foundDept.id);
                                return {
                                    ...foundDept,
                                    name_uz: name,
                                    short_id: targetShortId
                                };
                            } else {
                                return {
                                    id: 'manual-' + Math.random(),
                                    name_uz: name,
                                    short_id: targetShortId,
                                    is_new: false
                                };
                            }
                        }

                        // SPECIAL CASE: Force short_id for "Ijro intizomi, arxiv va murojaatlar bilan ishlash bo‘limi"
                        if (name.includes("Ijro intizomi, arxiv va murojaatlar bilan ishlash bo‘limi")) {
                            const targetShortId = "ijro-intizomi";

                            let foundDept = currentDepts.find(d => {
                                if (usedIds.has(d.id)) return false;
                                const dbName = normalize(d.name_uz);
                                return dbName.includes(normName) || normName.includes(dbName);
                            });

                            if (foundDept) {
                                usedIds.add(foundDept.id);
                                return {
                                    ...foundDept,
                                    name_uz: name,
                                    short_id: targetShortId
                                };
                            } else {
                                return {
                                    id: 'manual-' + Math.random(),
                                    name_uz: name,
                                    short_id: targetShortId,
                                    is_new: false
                                };
                            }
                        }

                        // 1. Search in current departments
                        // We filter out already used departments to prevent duplicates
                        let foundDept = currentDepts.find(d => {
                            if (usedIds.has(d.id)) return false;
                            const dbName = normalize(d.name_uz);
                            return dbName.includes(normName) || normName.includes(dbName);
                        });

                        if (foundDept) {
                            usedIds.add(foundDept.id);
                            return {
                                ...foundDept,
                                name_uz: name // Override name to match requested list
                            };
                        }

                        // 2. Search in global rectors (Pro-Rectors)
                        let foundRector = data.find(r => {
                            if (r === rector) return false;
                            const uniqueId = r.employee ? 'emp-' + r.employee.id : 'rec-' + r.id;
                            if (usedIds.has(uniqueId)) return false;

                            const dbPos = normalize(r.position_uz);
                            return r.position_uz && (dbPos.includes(normName) || normName.includes(dbPos));
                        });

                        if (foundRector) {
                            const uniqueId = foundRector.employee ? 'emp-' + foundRector.employee.id : 'rec-' + foundRector.id;
                            if (!usedIds.has(uniqueId)) {
                                usedIds.add(uniqueId);
                                foundRector.hidden = true;
                                return {
                                    id: foundRector.employee?.id,
                                    name_uz: name, // Override here too
                                    name_ru: foundRector.position_ru,
                                    name_en: foundRector.position_en,
                                    type: 'employee',
                                    short_id: 'emp-' + foundRector.id
                                };
                            }
                        }

                        // 3. Fallback: Create new
                        return {
                            id: 'manual-' + Math.random(),
                            name_uz: name,
                            short_id: '#',
                            is_new: true
                        };
                    });

                    rector.departments = newDepts;
                }

                // Filter out hidden 
                data = data.filter(r => !r.hidden);
                // NEW: Handle "Yoshlar masalalari" pro-rector sequence
                const yoshlarProRectorIndex = data.findIndex(r => r.position_uz && normalize(r.position_uz).includes('yoshlar') && normalize(r.position_uz).includes('prorektor'));

                if (yoshlarProRectorIndex !== -1) {
                    const yoshlarRector = data[yoshlarProRectorIndex];
                    let currentDepts = yoshlarRector.departments || [];

                    const manualSequenceYoshlar = [
                        "Yoshlar bilan ishlash, ma’naviyat va ma’rifat boshqarmasi",
                        "Axborot-resurs markazi",
                        "Tyutorlar faoliyatini muvofiqlashtirish bo‘limi",
                        "Psixolog",
                        "Yoshlar uyushmasi, klublar va to‘garaklar",
                        "Sport klubi kotibi"
                    ];

                    const usedIdsYoshlar = new Set();

                    const newDeptsYoshlar = manualSequenceYoshlar.map(name => {
                        const normName = normalize(name);
                        // Find department
                        let foundDept = currentDepts.find(d => {
                            if (usedIdsYoshlar.has(d.id)) return false;
                            const dbName = normalize(d.name_uz);
                            return dbName.includes(normName) || normName.includes(dbName);
                        });

                        if (foundDept) {
                            usedIdsYoshlar.add(foundDept.id);
                            return {
                                ...foundDept,
                                name_uz: name
                            };
                        }

                        // Fallback
                        return {
                            id: 'manual-yoshlar-' + Math.random(),
                            name_uz: name,
                            short_id: '#', // Placeholder unless we know specifically
                            is_new: true
                        };
                    });

                    yoshlarRector.departments = newDeptsYoshlar;
                }

                // Handle "Ilmiy ishlar" pro-rector sequence
                const ilmiyProRectorIndex = data.findIndex(r =>
                    r.position_uz && normalize(r.position_uz).includes('ilmiy') && normalize(r.position_uz).includes('prorektor')
                );

                if (ilmiyProRectorIndex !== -1) {
                    const ilmiyRector = data[ilmiyProRectorIndex];
                    let currentDepts = ilmiyRector.departments || [];

                    const manualSequenceIlmiy = [
                        "Ilmiy tadqiqotlar, innovatsiyalar, ilmiy-pedagog kadrlarni tayyorlash va iqtidorli talabalar bilan ishlash boshqarmasi",
                    ];

                    // Keep any existing departments not in manualSequenceIlmiy and append manual ones first
                    const usedIdsIlmiy = new Set();

                    const manualDepts = manualSequenceIlmiy.map(name => {
                        const normName = normalize(name);
                        let foundDept = currentDepts.find(d => {
                            if (usedIdsIlmiy.has(d.id)) return false;
                            const dbName = normalize(d.name_uz);
                            return dbName.includes(normName) || normName.includes(dbName);
                        });

                        if (foundDept) {
                            usedIdsIlmiy.add(foundDept.id);
                            if (normName.includes("ilmiy tadqiqotlar")) {
                                return { ...foundDept, id: 11, short_id: 'ilmiy-tadqiqotlar', name_uz: name, is_new: false };
                            }
                            return { ...foundDept, name_uz: name };
                        }

                        // Fallback: Force short_id if name matches
                        const isIlmiy = normName.includes("ilmiy tadqiqotlar");
                        return {
                            id: isIlmiy ? 'manual-ilmiy-11' : 'manual-ilmiy-' + Math.random(),
                            name_uz: name,
                            short_id: isIlmiy ? 'ilmiy-tadqiqotlar' : '#',
                            is_new: !isIlmiy
                        };
                    });

                    // Remaining existing departments not yet placed
                    const remainingDepts = currentDepts.filter(d => !usedIdsIlmiy.has(d.id));
                    ilmiyRector.departments = [...manualDepts, ...remainingDepts];
                }

                // Handle "Iqtisodiy va xo‘jalik" pro-rector sequence
                let iqtisodiyProRectorIndex = data.findIndex(r =>
                    r.position_uz && (normalize(r.position_uz).includes('iqtisodiy') || normalize(r.position_uz).includes('xorijiy ta') || normalize(r.position_uz).includes('xorijiy ta’lim'))
                );

                // If not found, create a placeholder rector so it always shows up
                if (iqtisodiyProRectorIndex === -1) {
                    const newRector = {
                        id: 'iqtisodiy-manual-section',
                        position_uz: "Iqtisodiy va xo‘jalik ishlari bo‘yicha prorektor",
                        departments: [],
                        is_manual_rector: true
                    };
                    data.push(newRector);
                    iqtisodiyProRectorIndex = data.length - 1;
                }

                if (iqtisodiyProRectorIndex !== -1) {
                    const iqtisodiyRector = data[iqtisodiyProRectorIndex];
                    iqtisodiyRector.hidden = false; // Force visible
                    let currentDepts = iqtisodiyRector.departments || [];

                    const manualSequenceIqtisodiy = [
                        "Buxgalteriya",
                        "Ishlar boshqarmasi",
                        "Bosh muhandis-texnolog",
                        "Texnik foydalanish va xo‘jalik bo‘limi"
                    ];

                    const usedIdsIqtisodiy = new Set();
                    const mainRector = data.find(r => r.position_uz && normalize(r.position_uz).includes('rektor') && !normalize(r.position_uz).includes('prorektor'));

                    const newDeptsIqtisodiy = manualSequenceIqtisodiy.map(name => {
                        const normName = normalize(name);

                        // 1. Search in own depts
                        let foundDept = currentDepts.find(d => {
                            if (usedIdsIqtisodiy.has(d.id)) return false;
                            const dbName = normalize(d.name_uz);
                            return dbName.includes(normName) || normName.includes(dbName);
                        });

                        // 2. Search in main rector's already populated depts (to move it)
                        if (!foundDept && mainRector && mainRector.departments) {
                            const foundIndex = mainRector.departments.findIndex(d => {
                                const dbName = normalize(d.name_uz);
                                return dbName.includes(normName) || normName.includes(dbName);
                            });

                            if (foundIndex !== -1) {
                                foundDept = mainRector.departments[foundIndex];
                                // Remove from main rector
                                mainRector.departments.splice(foundIndex, 1);
                            }
                        }

                        if (foundDept) {
                            usedIdsIqtisodiy.add(foundDept.id);
                            // Ensure specific short_ids for working links if we know them
                            if (normName.includes("buxgalteriya") || normName.includes("moliya")) {
                                foundDept.short_id = "bugalteriya-reja-moliya-bolimi";
                            }
                            if (normName.includes("ijro intizomi")) foundDept.short_id = "ijro-intizomi";

                            return { ...foundDept, name_uz: name };
                        }

                        // Fallback: Create new
                        let fallbackShortId = "#";
                        if (normName.includes("buxgalteriya") || normName.includes("moliya")) {
                            fallbackShortId = "bugalteriya-reja-moliya-bolimi";
                        }
                        if (normName.includes("ijro intizomi")) fallbackShortId = "ijro-intizomi";

                        return {
                            id: 'manual-iqtisodiy-' + Math.random(),
                            name_uz: name,
                            short_id: fallbackShortId,
                            is_new: fallbackShortId === "#"
                        };
                    });

                    iqtisodiyRector.departments = newDeptsIqtisodiy;
                }
                const updatedData = data.map(rector => {
                    const pos = rector.position_uz || "";
                    if (pos.includes("Ilmiy ishlar")) {
                        return {
                            ...rector,
                            position_uz: "Ilmiy ishlar va inovatsiyalar bo'yicha prorektor"
                        };
                    } else if (pos.includes("Iqtisodiy") || pos.includes("Xorijiy ta'lim") || pos.includes("xorijiy ta'lim") || pos.includes("Xorijiy ta’lim")) {
                        return {
                            ...rector,
                            position_uz: "Iqtisodiy va xo‘jalik ishlari bo‘yicha prorektor",
                            disableLink: true
                        };
                    }

                    // Remove the department from the "Ta'lim sifati" card (fixing duplication)
                    if (pos.includes("Ta'lim sifati nazorati")) {
                        return {
                            ...rector,
                            departments: (rector.departments || []).filter(d =>
                                !normalize(d.name_uz).includes("ilmiy tadqiqotlar")
                            )
                        };
                    }

                    return rector;
                }).filter(rector => {
                    // Remove "Xalqaro hamkorlik bo'yicha prorektor" standalone card
                    const pos = normalize(rector.position_uz || "");
                    return !(pos.includes("xalqaro hamkorlik") && pos.includes("prorektor"));
                });
                setRectors(updatedData);
            })
            .catch((error) => console.error("Error fetching rectors data: ", error));
    }, [i18n.language]);

    const nameToKey = {
        "Xalqaro hamkorlik bo‘yicha prorektor": "prorektor_xalqaro",
        "Xalqaro hamkorlik va reytinglar bilan ishlash boshqarmasi": "boshqarma_xalqaro",
        "Xorijiy ta’lim hamkorligi markazlari rahbari-prorektor": "prorektor_xorijiy",
        "Rektor apparati – rektor yordamchisi va maslahatchilari": "rektor_apparati",
        "Inson resurslarini boshqarish boshqarmasi": "boshqarma_inson_resurslari",
        "Universitet axborot xizmati": "axborot_xizmati_uni",
        "Yuriskonsult, “Komplayens nazorat”": "yuriskonsult_komplayens",
        "Kengashlar va majlislar kotibi": "kotib_kengashlar",
        "Ijro intizomi, arxiv va murojaatlar bilan ishlash bo‘limi": "bolim_ijro_intizomi",
        "Yoshlar bilan ishlash, ma’naviyat va ma’rifat boshqarmasi": "boshqarma_yoshlar",
        "Axborot-resurs markazi": "axborot_resurs_markazi_uni",
        "Tyutorlar faoliyatini muvoxiqlashtirish bo‘limi": "bolim_tyutorlar",
        "Psixolog": "psixolog",
        "Yoshlar uyushmasi, klublar va to‘garaklar": "klublar_togaraklar",
        "Sport klubi kotibi": "sport_klubi_kotibi",
        "Ilmiy tadqiqotlar, innovatsiyalar, ilmiy-pedagog kadrlarni tayyorlash va iqtidorli talabalar bilan ishlash boshqarmasi": "boshqarma_ilmiy",
        "Buxgalteriya": "buxgalteriya",
        "Ishlar boshqarmasi": "ishlar_boshqarmasi",
        "Bosh muhandis-texnolog": "muhandis_texnolog",
        "Texnik foydalanish va xo‘jalik bo‘limi": "bolim_xo'jalik",
        "Ilmiy ishlar va inovatsiyalar bo'yicha prorektor": "prorektor_ilmiy",
        "Iqtisodiy va xo‘jalik ishlari bo‘yicha prorektor": "prorektor_iqtisodiy"
    };

    const getTranslatedName = (item, nameField, posField) => {
        const uzName = item[nameField] || item[posField];
        if (uzName && nameToKey[uzName]) {
            return t(nameToKey[uzName]);
        }

        if (i18n.language === 'uz') return uzName;
        const langBody = (nameField && item[`${nameField.split('_')[0]}_${i18n.language}`]) ||
            (posField && item[`${posField.split('_')[0]}_${i18n.language}`]);

        return langBody || uzName;
    };

    const getIcon = (name) => {
        const n = name.toLowerCase();
        if (n.includes("xodim")) return <FaUsersCog />;
        if (n.includes("arxiv") || n.includes("monitoring") || n.includes("ijro")) return <FaFileAlt />;
        if (n.includes("yurist") || n.includes("kurashish") || n.includes("komplayens")) return <FaBalanceScale />;
        if (n.includes("auditor")) return <FaSearch />;
        if (n.includes("matbuot") || n.includes("axborot")) return <FaBullhorn />;
        if (n.includes("kengash")) return <FaBriefcase />;
        if (n.includes("xalqaro")) return <FaGlobe />;
        if (n.includes("yoshlar") || n.includes("ma'naviyat")) return <FaBook />;
        if (n.includes("psixolog")) return <FaBrain />;
        if (n.includes("hamshira")) return <FaStethoscope />;
        if (n.includes("o'quv") || n.includes("boshqarma")) return <FaGraduationCap />;
        if (n.includes("marketing")) return <FaChartLine />;
        if (n.includes("laboratoriya")) return <FaFlask />;
        if (n.includes("innovatsiya") || n.includes("tadqiqot")) return <FaMicroscope />;
        if (n.includes("sifat")) return <FaAward />;
        if (n.includes("it") || n.includes("raqamli") || n.includes("resurs")) return <FaLaptopCode />;
        if (n.includes("buxgalteriya") || n.includes("moliya")) return <FaCalculator />;
        if (n.includes("xo'jalik")) return <FaHistory />;
        if (n.includes("muhandis")) return <FaCogs />;
        return <FaUniversity />;
    };

    return (
        <div className={styles.mainContainer}>
            <h1 className={styles.pageTitle}>{t("universityStructure") || "Universitet Tuzilmasi"}</h1>

            <div className={styles.structureList}>
                {rectors.map((rector, index) => {
                    // Check if this is the main Rector (not Pro-Rector)
                    const isMainRector = (rector.position_uz || "").toLowerCase().includes('rektor') && !(rector.position_uz || "").toLowerCase().includes('prorektor');

                    return (
                        <div key={rector.id || index} className={styles.sectionContainer}>
                            {isMainRector ? (
                                // Float Layout for Main Rector
                                <div className={styles.wrapper}>
                                    {/* Left Side Side-Box */}
                                    {rector.disableLink ? (
                                        <div className={`${styles.sideBox} ${styles.floatSideBox}`} style={{ cursor: "default" }}>
                                            <div className={styles.sideIcon}><FaUniversity /></div>
                                            <h3 className={styles.sideTitle}>
                                                {getTranslatedName(rector, null, 'position_uz')}
                                            </h3>
                                        </div>
                                    ) : (
                                        <Link to={`/employee/${rector.employee?.id}`} className={`${styles.sideBox} ${styles.floatSideBox}`}>
                                            <div className={styles.sideIcon}><FaUniversity /></div>
                                            <h3 className={styles.sideTitle}>
                                                {getTranslatedName(rector, null, 'position_uz')}
                                            </h3>
                                        </Link>
                                    )}

                                    {/* Departments - Direct Children for Float Layout */}
                                    {rector.departments && rector.departments.map((dept, idx) => {
                                        let link = dept.short_id ? `/centers/${dept.short_id}` : `/centers/${dept.id}`;
                                        if (dept.type === 'employee') link = `/employee/${dept.id}`;
                                        else if (dept.is_new) link = "#";

                                        return (
                                            <Link
                                                key={dept.id || idx}
                                                to={link}
                                                className={`${styles.itemCard} ${styles.floatItem} ${dept.name_uz.toLowerCase().includes('prorektor') ? styles.proRectorCard : ''}`}
                                                onClick={(e) => { if (link === '#') e.preventDefault(); }}
                                            >
                                                <div className={styles.itemIcon}>{getIcon(dept.name_uz)}</div>
                                                <div className={styles.itemText}>
                                                    <h4>
                                                        {getTranslatedName(dept, 'name_uz', null)}
                                                    </h4>
                                                </div>
                                            </Link>
                                        );
                                    })}
                                </div>
                            ) : (
                                // Flex Layout for Pro-Rectors
                                <div className={styles.flexLayout}>
                                    {/* Left Side Side-Box */}
                                    {rector.disableLink ? (
                                        <div className={styles.sideBox} style={{ cursor: "default" }}>
                                            <div className={styles.sideIcon}><FaUniversity /></div>
                                            <h3 className={styles.sideTitle}>
                                                {getTranslatedName(rector, null, 'position_uz')}
                                            </h3>
                                        </div>
                                    ) : (
                                        <Link to={`/employee/${rector.employee?.id}`} className={styles.sideBox}>
                                            <div className={styles.sideIcon}><FaUniversity /></div>
                                            <h3 className={styles.sideTitle}>
                                                {getTranslatedName(rector, null, 'position_uz')}
                                            </h3>
                                        </Link>
                                    )}

                                    {/* Right Side Info & Grid */}
                                    <div className={styles.contentArea}>
                                        <div className={styles.itemsGrid}>
                                            {rector.departments && rector.departments.map((dept, idx) => {
                                                let link = dept.short_id ? `/centers/${dept.short_id}` : `/centers/${dept.id}`;
                                                if (dept.type === 'employee') link = `/employee/${dept.id}`;
                                                else if (dept.is_new) link = "#";

                                                return (
                                                    <Link
                                                        key={dept.id || idx}
                                                        to={link}
                                                        className={`${styles.itemCard} ${dept.name_uz.toLowerCase().includes('prorektor') ? styles.proRectorCard : ''}`}
                                                        onClick={(e) => { if (link === '#') e.preventDefault(); }}
                                                    >
                                                        <div className={styles.itemIcon}>{getIcon(dept.name_uz)}</div>
                                                        <div className={styles.itemText}>
                                                            <h4>
                                                                {getTranslatedName(dept, 'name_uz', null)}
                                                            </h4>
                                                        </div>
                                                    </Link>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Department;
